{
  "shcPP": {
    "addToCart": "Dodaj do koszyka",
    "sku": "sku",
    "theProductDoesNotExist": "Ten produkt nie istnieje"
  }
}
